<template>
  <!-- this component will render a form to be filled by site team which was configured in activity configurator -->
  <div class="pt-10" v-if="activityFormData.activity && activityFormData.activity.id">
    <div class="row" v-if="(showBanner == true || showBanner == undefined) && (lang == 'he' || lang == 'ar-IL')">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div
          class="ml-25 p-5 fw-bold fs-18 formName title-alignment"
          v-if="activityFormData.activity.showNumericLabels || activityFormData.activity.showNumericLabels == undefined || activityFormData.activity.showNumericLabels == null"
          v-translate:_name="{
            key: activityFormData.activity.id,
            val: lang,
            html: formName
          }"
        >
          {{ formName }}
        </div>
        <div
          v-else
          class="ml-55 p-5 fw-bold fs-18 formName"
          v-translate:_name="{
            key: activityFormData.activity.id,
            val: lang,
            html: formName
          }"
        >
          {{ formName }}
        </div>
      </div>
    </div>

    <div class="row" v-else-if="showBanner == true || showBanner == undefined">
      <div class="col-md-6">
        <div
          class="ml-25 p-5 fw-bold fs-18 col-md-12 formName"
          v-if="activityFormData.activity.showNumericLabels || activityFormData.activity.showNumericLabels == undefined || activityFormData.activity.showNumericLabels == null"
          v-translate:_name="{
            key: activityFormData.activity.id,
            val: lang,
            html: formName
          }"
        >
          {{ formName }}
        </div>
        <div
          v-else
          class="ml-55 p-5 fw-bold fs-18 col-md-12 formName"
          v-translate:_name="{
            key: activityFormData.activity.id,
            val: lang,
            html: formName
          }"
        >
          {{ formName }}
        </div>
      </div>
    </div>
    <b-row v-if="displayMobileView === false">
      <b-col v-for="(steps, index) in activityQuestions" :key="index" :class="(steps.length == 1 || steps.length == 0 ? 'col-md-12' : 'col-row') || (selectedId == steps.id ? 'selected' : '')" :id="selectedId === steps.id ? selectedId : ''" class="th-activity-edc-form-preview activty-demo" sm="12">
        <div
          :id="selectedId === step.id ? selectedId : ''"
          class="fieldCmp"
          :class="{
            _pointer: step.type != 'Section' && step.type != 'SurveyInstruction' && !isHistory && checkForChangeField(step.id),
            'col-md-6': steps.length == 2,
            'col-md-4': steps.length == 3
          }"
          :style="{
            backgroundColor: selectedId === step.id ? '#f9f9e0' : ''
          }"
          v-for="(step, innerIndex) in steps"
          :key="innerIndex"
        >
          <ActivtiyFormSectionPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Section'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />
          <ActivtiyFormNumberPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Number'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormBooleanPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            :trigger-validate="triggerValidation"
            v-if="step.type === 'Boolean'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormMultiChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'MultiChoice'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :showValidationMessage="showValidationMessage"
            @onValidateAnswer="onValidateAnswer"
            :sendMultiChoiceData="checkSendMultiChoiceData(step.id)"
            :nextStepSequence="nextQuestionSequence"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormTextPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Text'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormNumberScalePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'NumberScale'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :completeEdit="completeEdit"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormCustomScalePreview
            :id="step.id"
            :key="step.id"
            class
            :trigger-validate="triggerValidation"
            :componentData="step"
            v-if="step.type === 'CustomScale'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :completeEdit="completeEdit"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormVASPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'VAS'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormDateTimePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DateTime'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormImageChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            :trigger-validate="triggerValidation"
            v-if="step.type === 'Image'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :isClearData="step.isClearAnswer"
          />
          <ActivtiyFormInstructionStepPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'SurveyInstruction'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
          />

          <ActivtiyFormDropdownPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DropDown'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :nextStepSequence="nextQuestionSequence"
            :isClearData="step.isClearAnswer"
          />

          <ActivtiyFormLogPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Log'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            :isClearData="step.isClearAnswer"
          />

          <ActivtiyFormIndexPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            :trigger-validate="triggerValidation"
            v-if="step.type === 'Index'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :completeEdit="completeEdit"
            :isClearData="step.isClearAnswer"
          />

          <ActivtiyFormMeasurementsPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Measurements'"
            :trigger-validate="triggerValidation"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />

          <ActivtiyFormValidatedEntryPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            :trigger-validate="triggerValidation"
            v-if="step.type === 'ValidatedEntry'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @initAnswerChange="initAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :isClearData="step.isClearAnswer"
          />

          <button
            v-if="step.type != 'SurveyInstruction' && step.type != 'Section' && step.type != 'SurveyCompletion' && !isHistory && (canCraAccess || canDmAccess || canPharmacovigilanceAccess || canCraUBAccess || (canCallCenterAccess && showOpenQueryForCallCenter == true))"
            class="btn fw-bold fs-12 btnDisplay btn-outline-primary"
            :id="`open-query-popover-${step.id}`"
            :class="canCraOpenQuery ? 'disable-open-query-button' : 'btn-hover'"
            @click="openQuery(step.id)"
          >
            OPEN A QUERY
          </button>
          <b-popover v-if="canCraOpenQuery" :target="`open-query-popover-${step.id}`" triggers="hover" placement="bottomright"> You cannot open queries on locked activities. </b-popover>
        </div>
      </b-col>
    </b-row>
    <div v-if="displayMobileView === true">
      <!--v-for="step in activityFormData.activity.questions"-->
      <b-col v-for="(steps, index) in activityQuestions" :key="index" :class="(steps.length == 1 || steps.length == 0 ? 'col-md-12' : 'col-row') || (selectedId == steps.id ? 'selected' : '')" :id="selectedId === steps.id ? selectedId : ''" class="th-activity-edc-form-preview activty-demo">
        <div
          :id="selectedId === step.id ? selectedId : ''"
          class="fieldCmp"
          :class="{
            _pointer: step.type != 'Section' && step.type != 'SurveyInstruction' && !isHistory && checkForChangeField(step.id),
            'col-md-6': steps.length == 2,
            'col-md-4': steps.length == 3
          }"
          :style="{
            backgroundColor: selectedId === step.id ? '#f9f9e0' : ''
          }"
          v-for="(step, innerIndex) in steps"
          :key="innerIndex"
        >
          <ActivtiyFormSectionPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Section'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            :mode="modes[mode]"
            :lang="lang"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormNumberPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Number'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormBooleanPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Boolean'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormMultiChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'MultiChoice'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
            :showValidationMessage="showValidationMessage"
            @onValidateAnswer="onValidateAnswer"
            :sendMultiChoiceData="checkSendMultiChoiceData(step.id)"
          />
          <ActivtiyFormTextPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Text'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormNumberScalePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'NumberScale'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormCustomScalePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'CustomScale'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormVASPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'VAS'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormDateTimePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DateTime'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormImageChoicePreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Image'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />
          <ActivtiyFormInstructionStepPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'SurveyInstruction'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            @initAnswerChange="initAnswerChange"
          />

          <ActivtiyFormDropdownPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'DropDown'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
            :isClearData="step.isClearAnswer"
          />

          <ActivtiyFormLogPreview
            :id="step.id"
            class
            :key="step.id"
            :componentData="step"
            v-if="step.type === 'Log'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            @initAnswerChange="initAnswerChange"
            :trigger-validate="triggerValidation"
          />

          <ActivtiyFormIndexPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Index'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
            :completeEdit="completeEdit"
          />

          <ActivtiyFormMeasurementsPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'Measurements'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />

          <ActivtiyFormValidatedEntryPreview
            :id="step.id"
            :key="step.id"
            class
            :componentData="step"
            v-if="step.type === 'ValidatedEntry'"
            :isFieldDisabled="userIsStudyAdmin || disabledFields[step.id]"
            @onAnswerChange="onAnswerChange"
            @getQuestionScores="updateSectionScores"
            @onClearAnswer="onClearAnswer"
            :lang="lang"
            :mode="modes[mode]"
            :isEdited="checkForChangeField(step.id)"
            @click.native="select(step.id)"
            :activityInfo="activityFormData.activity"
            :isNotificationIcon="isNotificationIcon"
            :trigger-validate="triggerValidation"
            @initAnswerChange="initAnswerChange"
          />

          <button
            v-if="step.type != 'SurveyInstruction' && step.type != 'Section' && step.type != 'SurveyCompletion' && !isHistory && (canCraAccess || canDmAccess || canCraUBAccess) && activityFormData"
            class="btn fw-bold fs-12 btnDisplay btn-outline-primary"
            @click="openQuery(step.id)"
            :id="`open-query-popover-${step.id}`"
            :class="canCraOpenQuery ? 'disable-open-query-button' : 'btn-hover'"
          >
            OPEN A QUERY
          </button>
          <b-popover v-if="canCraOpenQuery" :target="`open-query-popover-${step.id}`" triggers="hover" placement="bottomright"> You cannot open queries on locked activities. </b-popover>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { CRA, DM, PHV, CC, CraUB } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import _ from "lodash";

import ActivtiyFormNumberPreview from "@/components/activity-form/preview-components/activity-form-number-preview.vue";
import ActivtiyFormBooleanPreview from "@/components/activity-form/preview-components/activity-form-boolean-preview.vue";
import ActivtiyFormMultiChoicePreview from "@/components/activity-form/preview-components/activity-form-multi-choice-preview.vue";
import ActivtiyFormTextPreview from "@/components/activity-form/preview-components/activity-form-text-preview.vue";
import ActivtiyFormNumberScalePreview from "@/components/activity-form/preview-components/activity-form-number-scale-preview.vue";
import ActivtiyFormCustomScalePreview from "@/components/activity-form/preview-components/activity-form-custom-scale-preview.vue";
import ActivtiyFormVASPreview from "@/components/activity-form/preview-components/activity-form-vas-preview.vue";
import ActivtiyFormDateTimePreview from "@/components/activity-form/preview-components/activity-form-date-time-preview.vue";
import ActivtiyFormImageChoicePreview from "@/components/activity-form/preview-components/activity-form-image-choice-preview.vue";
import ActivtiyFormInstructionStepPreview from "@/components/activity-form/preview-components/activity-form-instruction-step-preview.vue";
import ActivtiyFormSectionPreview from "@/components/activity-form/preview-components/activity-form-section-preview.vue";
import ActivtiyFormDropdownPreview from "@/components/activity-form/preview-components/activity-form-dropdown-preview.vue";
import ActivtiyFormLogPreview from "@/components/activity-form/preview-components/activity-form-log-preview.vue";
import ActivtiyFormMeasurementsPreview from "@/components/activity-form/preview-components/activity-form-measurements-preview.vue";
import ActivtiyFormIndexPreview from "@/components/activity-form/preview-components/activity-form-index-preview.vue";
import ActivtiyFormValidatedEntryPreview from "@/components/activity-form/preview-components/activity-form-validate-entry-preview.vue";
import * as activityService from "@/components/services/activity-service";
import * as constant from "../../constants/config";
import swal from "sweetalert2";
import localStorageService from "@/services/localStorage";

export default {
  components: {
    ActivtiyFormSectionPreview,
    ActivtiyFormNumberPreview,
    ActivtiyFormBooleanPreview,
    ActivtiyFormMultiChoicePreview,
    ActivtiyFormTextPreview,
    ActivtiyFormNumberScalePreview,
    ActivtiyFormCustomScalePreview,
    ActivtiyFormVASPreview,
    ActivtiyFormDateTimePreview,
    ActivtiyFormImageChoicePreview,
    ActivtiyFormInstructionStepPreview,
    ActivtiyFormDropdownPreview,
    ActivtiyFormLogPreview,
    ActivtiyFormMeasurementsPreview,
    ActivtiyFormIndexPreview,
    ActivtiyFormValidatedEntryPreview
  },
  props: {
    showBanner: {
      type: Boolean,
      default: true
    },
    formName: null,
    activityFormData: {},
    applyBranchingLogic: {
      default: true
    },
    mode: {
      default: 0
    },
    triggerValidation: {
      type: Boolean,
      default: false
    },
    isHistory: null,
    queryIds: null,
    selectedFieldId: null,
    selectedId: null,
    queries: {
      type: Array
    },
    isNotificationIcon: Boolean,
    createdById: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: "EN"
    },
    showValidationMessage: {
      type: Boolean,
      default: false
    },
    validationCount: {
      type: Number,
      default: 0
    },
    completeEdit: {
      type: Boolean,
      default: false
    },
    lockStatus: {
      type: String,
      default: ""
    }
  },
  methods: {
    openQuery(id) {
      if (this.canCraOpenQuery) {
        return true;
      }
      this.querySelectedID = id;
      setTimeout(() => {
        const offsetData = document.getElementById(this.selectedId).parentElement;
        this.getOffsetValue = offsetData.offsetTop;
        this.$root.$emit("openQueriesFormOpen", offsetData.offsetTop);
      }, 80);
      this.$emit("openQuery", id, this.getOffsetValue);
      return false;
    },
    checkForChangeField(id) {
      return this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length;
    },
    hasQueryCreated(id) {
      if (this.canCraAccess || this.canCraUBAccess || this.canPharmacovigilanceAccess || this.canDmAccess) {
        return this.queries && this.queries.filter(q => q.fieldId === id);
      }
      const totalQueries = [];
      this.queries &&
        this.queries.filter(query => {
          if (query.fieldId === id) {
            if (query.assigneeId) {
              if (this.user.id === query.assigneeId) {
                totalQueries.push(query);
              }
            } else {
              totalQueries.push(query);
            }
          }
        });
      return totalQueries;
    },
    select(id) {
      if (this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length) {
        this.$emit("selected", id);
      }
    },
    isQueryIdPrsent(id) {
      return this.canCraAccess || this.canCraUBAccess ? this.queries && this.queries.filter(q => q.fieldId === id) : this.queries && this.queries.filter(q => q.fieldId === id && q.assigneeId === this.user.id);
    },
    scrollToId() {
      if (this.selectedId) {
        let autoScroll = window.document.getElementById(`${this.selectedId}`);
        if (autoScroll != null && autoScroll != undefined) {
          autoScroll.scrollIntoViewIfNeeded(true);
        }
      }
    },
    setErrorFieldsOnEachStep() {
      this.activityFormData.activity.questions.forEach(step => {
        this.$set(step, "hasFieldError", false);
        this.$set(step, "fieldErrorText", "");
      });
    },
    initAnswerChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      if (this.applyBranchingLogic && this.mode == "EDIT") {
        this.disabledFields = this.branchingLogic.checkLogic(step);
        this.$emit("disabledFields", this.disabledFields);
      }
    },
    onAnswerChange(step) {
      const selectedAnswerQids = [];
      if (step.branchingConfigured) {
        this.nextQuestionSequence = this.branchingLogic.getNextStepSquenceFromId(step, this.activityFormData.activity);
        this.$emit("nextStepSequence", this.nextQuestionSequence);
      }
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      step.isClearAnswer = false;

      if (this.applyBranchingLogic && this.mode == "EDIT") {
        this.disabledFields = this.branchingLogic.checkLogic(step);
        this.$emit("disabledFields", this.disabledFields);
        if (this.disabledFields && step.branchingConfigured) {
          const obj = this.disabledFields;
          const keys = Object.keys(obj);
          const disabledFieldsWithTrueData = keys.filter(function (key) {
            return obj[key];
          });

          this.activityFormData.activity.questions.forEach(ques => {
            if (ques && ques.hasOwnProperty("optionsIds") && ques.optionsIds.length > 0 && ques.optionsIds[0] != null) {
              if (["Image", "MultiChoice"].includes(ques.type)) {
                selectedAnswerQids.push(ques.id);
              }
            }
            if (ques && ques.hasOwnProperty("answerId") && ques.type === "Boolean") {
              if (ques.answerId && ques.answerId !== "" && ques.answerId !== null) {
                selectedAnswerQids.push(ques.id);
              }
            }
            if (ques && ques.hasOwnProperty("answer") && !["CustomScale", "NumberScale", "Boolean"].includes(ques.type)) {
              if (ques.answer && ques.answer !== "" && ques.answer !== null) {
                selectedAnswerQids.push(ques.id);
              }
            }
            if (ques && ques.hasOwnProperty("defaultAnswer")) {
              if (ques.defaultAnswer && ques.defaultAnswer !== "" && ques.defaultAnswer !== null) {
                if (ques.hasOwnProperty("formattedLabels") && ques.formattedLabels[0] !== ques.defaultAnswer && ques.type == "CustomScale") {
                  selectedAnswerQids.push(ques.id);
                }
                if (ques.hasOwnProperty("minValue") && ques.minValue !== ques.defaultAnswer && ques.type == "NumberScale") {
                  selectedAnswerQids.push(ques.id);
                }
              }
            }
          });
          const uniqueSelectedIds = selectedAnswerQids.length > 0 ? selectedAnswerQids.filter((v, i, a) => a.indexOf(v) === i) : [];
          if (disabledFieldsWithTrueData.length > 0) {
            const intersectionOfQid = disabledFieldsWithTrueData.filter(qid => uniqueSelectedIds.includes(qid));
            if (intersectionOfQid.length > 0 && step.branchingConfigured) {
              this.isSiteTeamResponseAdded(step);
            }
          }
        }
      }
      if (this.mode == "EDIT") {
        this.updateSectionScores();
      }
    },

    isSiteTeamResponseAdded(step) {
      swal({
        title: `By providing this response, some previously answered questions are no longer applicable and your responses will be removed. 
              
              Do you wish to continue?`,
        type: "",
        showCancelButton: true,
        cancelButtonColor: "#f16559",
        confirmButtonColor: "#4c8ce4",
        cancelButtonText: "Cancel",
        confirmButtonText: "Continue",
        reverseButtons: true,
        customClass: "custom-cancel",
        allowOutsideClick: false
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          step.isClearAnswer = true;
          this.$forceUpdate();
        } else {
          step.isClearAnswer = false;
        }
      });
    },

    updateSectionScores() {
      if (this.activityFormData && this.activityFormData.activity && this.activityFormData.activity.canScoreResponses) {
        this.$emit("getQuestionScores");
        setTimeout(() => {
          const allQuestions = this.activityFormData.activity.questions;
          this.activityQuestions = allQuestions.map(item => [item]);
        }, 200);
      } else {
        const allQuestions = this.activityFormData.activity.questions;
        this.activityQuestions = allQuestions.map(item => [item]);
      }
    },
    onClearAnswer(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;
      if (this.applyBranchingLogic && this.mode == "EDIT") {
        this.disabledFields = this.branchingLogic.clearLogic(step);
        this.$emit("disabledFields", this.disabledFields, true);
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    refresh() {},
    isPacketPending() {
      if (this.$route.name == "study-participant-edc-unschedule-form-reskin" && this.canCallCenterAccess) {
        return true;
      } else {
        return false;
      }
    },
    getCreatedByUserData() {
      if (this.user && this.user.siteIds && this.user.siteIds[0]) {
        const siteId = this.user.siteIds[0];
        this.$api.getSiteTeamFact(this.$route.params.studyId, siteId).then(response => {
          const siteTeamList = response.body;
          const createdByUserData = siteTeamList.filter(el => {
            return this.createdById == el.id;
          });
          if (createdByUserData.length > 0 && Object.keys(createdByUserData[0]).includes("userRole") && ((createdByUserData[0].userRole == "CallCenter" && this.$route.params.label.toLowerCase() !== "pending") || createdByUserData[0].userRole == "HomeHealth")) {
            this.showOpenQueryForCallCenter = true;
          }
        });
      }
    },
    onValidateAnswer(data) {
      const getIndex = this.getValidationDataMultipleChoice.findIndex(dt => dt.id === data.id);
      this.getValidationDataMultipleChoice[getIndex].showValidationMessage = false;
      for (let i = 0; i < this.getValidationDataMultipleChoice.length; i++) {
        const getResult = this.disabledFields[this.getValidationDataMultipleChoice[i].id];
        if (getResult) {
          this.getValidationDataMultipleChoice[i].showValidationMessage = false;
        }
      }
      this.$emit("onValidateAnswer");
    },
    checkSendMultiChoiceData(id) {
      const filterData = this.getValidationDataMultipleChoice.filter(data => data.id === id);
      return filterData[0];
    }
  },
  data() {
    return {
      querySelectedID: null,
      getOffsetValue: null,
      activityQuestions: [],
      disabledFields: [],
      disabledFieldsOld: [],
      modes: {
        PREVIEW: 0,
        EDIT: 1,
        RESPONSE: 2
      },
      showOpenQueryForCallCenter: false,
      displayMobileView: Boolean,
      getValidationDataMultipleChoice: [],
      nextQuestionSequence: null,
      tempActivityFormData: {}
    };
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  watch: {
    selectedId: {
      handler() {
        this.scrollToId();
      }
    },
    activityFormData: {
      handler() {
        if (this.activityFormData.activity) {
          this.activityFormData.activity = activityService.replacePastXMonthsString(this.activityFormData.activity, this.$route.params.studyId);
          this.getCreatedByUserData();
          this.activityQuestions = activityService.getActivityColumnStructure(this.activityFormData.activity);
          this.branchingLogic = new activityService.Branching(false, this.activityFormData.activity.questions);
          this.getValidationDataMultipleChoice = this.activityQuestions.map(data => {
            const obj = {};
            obj.id = data[0].id;
            obj.type = data[0].type;
            obj.showValidationMessage = false;
            return obj;
          });
          this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.filter(dt => dt.type === "MultiChoice");
        }
      }
    },
    validationCount: {
      handler(val) {
        if (val) {
          this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.map(data => {
            const obj = data;
            obj.showValidationMessage = true;
            return obj;
          });
        }
        if (this.activityFormData.activity.questions) {
          _.forEach(this.activityFormData.activity.questions, (value, index) => {
            if (value.optionsIds) {
              if (value.optionsIds.length === 1 && value.optionsIds[0] === null) {
                this.activityFormData.activity.questions[index].optionsIds = [];
              }
            }
          });
        }
      }
    }
  },
  mounted() {
    this.scrollToTop();
    if (this.activityFormData && this.activityFormData.activity) {
      this.activityFormData.activity = activityService.replacePastXMonthsString(this.activityFormData.activity, this.$route.params.studyId);
      this.activityQuestions = activityService.getActivityColumnStructure(this.activityFormData.activity);
      this.branchingLogic = new activityService.Branching(false, this.activityFormData.activity.questions);
      this.getValidationDataMultipleChoice = this.activityQuestions.map(data => {
        const obj = {};
        obj.id = data[0].id;
        obj.type = data[0].type;
        obj.showValidationMessage = false;
        return obj;
      });
      this.getValidationDataMultipleChoice = this.getValidationDataMultipleChoice.filter(dt => dt.type === "MultiChoice");
    }
  },
  computed: {
    ...mapGetters(["user"]),
    userIsStudyAdmin() {
      return this.user.userRole === "StudyAdmin";
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    stepsMap() {
      const stepsMap = {};
      if (this.activityFormData && this.activityFormData.activity.questions && this.activityFormData.activity.questions.length) {
        this.activityFormData.activity.questions.forEach(step => (stepsMap[step.id] = step));
      }
      return stepsMap;
    },
    canCraOpenQuery() {
      let userObj = localStorageService.getItem("userObj");
      if (userObj.restrictions !== "" && this.lockStatus && this.lockStatus.toLowerCase() === "locked") {
        return !!userObj.restrictions.includes("activity_response_query.open_locked");
      }
      return false;
    }
  },
};
</script>

<style scoped lang="scss">
.col.row {
  margin: 0 -15px !important;
}
.col-row {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
}
.btnDisplay {
  top: 10px;
  right: 10px;
  position: absolute;
  border-color: #d3dfe4;
  background-color: #fff;
}
.disable-open-query-button {
  opacity: 0.3;
}
.disable-open-query-button:hover {
  color: #4c8ce4 !important;
  background-color: transparent !important;
}
.btn-hover:hover {
  color: #fff !important;
  background-color: #4c8ce4 !important;
}
.fieldCmp {
  color: #666669;
}
.form-components:last-of-type {
  padding-bottom: 15px;
}
.fieldCmp:hover + .btn-hover,
.btn-hover:hover {
  display: block;
}
.selected {
  background: #f9f9e0;
  border-color: #d3dfe4;
}
@media (min-width: 320px) and (max-width: 768px) {
  .formName {
    margin-left: 0px !important;
  }
}
.que-opacity {
  opacity: 0.4;
}
.title-alignment {
  float: right;
  margin-right: 40px;
}
.left-lign {
  text-align: left !important;
}
</style>
